import TemplatesActionTypes from 'redux/template/types';

const templatesActionCreator = ({ type, ...payload }) => ({
  type,
  payload,
});

export const startFetchEmailUserTemplate = ({ ...data }) =>
  templatesActionCreator({
    type: TemplatesActionTypes.START_FETCH_EMAIL_USER_TEMPLATES,
    ...data,
  });

export const startFetchEmailSystemTemplate = ({ ...data }) =>
  templatesActionCreator({
    type: TemplatesActionTypes.START_FETCH_EMAIL_SYSTEM_TEMPLATES,
    ...data,
  });

export const startFetchDocumentUserTemplate = ({ ...data }) =>
  templatesActionCreator({
    type: TemplatesActionTypes.START_FETCH_DOCUMENT_USER_TEMPLATES,
    ...data,
  });

export const startFetchDocumentSystemTemplate = ({ ...data }) =>
  templatesActionCreator({
    type: TemplatesActionTypes.START_FETCH_DOCUMENT_SYSTEM_TEMPLATES,
    ...data,
  });

export const startFetchSmsUserTemplate = ({ ...data }) =>
  templatesActionCreator({
    type: TemplatesActionTypes.START_FETCH_SMS_USER_TEMPLATES,
    ...data,
  });

export const startFetchSmsSystemTemplate = ({ ...data }) =>
  templatesActionCreator({
    type: TemplatesActionTypes.START_FETCH_SMS_SYSTEM_TEMPLATES,
    ...data,
  });

export const fetchTemplateSuccess = (data) => ({
  type: TemplatesActionTypes.FETCH_TEMPLATES_SUCCESS,
  payload: data,
});

export const fetchTemplateFailure = (error) => ({
  type: TemplatesActionTypes.FETCH_TEMPLATES_FAILURE,
  payload: error,
});

// del user template
export const startDeleteTemplate = (id, type) => ({
  type: TemplatesActionTypes.START_DELETE_TEMPLATES,
  payload: { id, type },
});

export const deleteTemplateSuccess = (id, type) => ({
  type: TemplatesActionTypes.DELETE_TEMPLATES_SUCCESS,
  payload: { id, type },
});

export const deleteTemplateFailure = (error) => ({
  type: TemplatesActionTypes.DELETE_TEMPLATES_FAILURE,
  payload: error,
});

// fetch single template
export const fetchSingleTemplate = (id, cb) => ({
  type: TemplatesActionTypes.FETCH_SINGLE_TEMPLATE,
  payload: { id, cb },
});

export const fetchSingleTemplateSuccess = (data) => ({
  type: TemplatesActionTypes.FETCH_SINGLE_TEMPLATE_SUCCESS,
  payload: data,
});

export const fetchSingleTemplateFailure = (error) => ({
  type: TemplatesActionTypes.FETCH_SINGLE_TEMPLATE_FAILURE,
  payload: error,
});

// update template
export const updateEmailTemplate = (id, active, name, cb) => ({
  type: TemplatesActionTypes.UPDATE_EMAIL_TEMPLATE_START,
  payload: { id, active, name, cb },
});

export const updateDocumentTemplate = (id, active, name, cb) => ({
  type: TemplatesActionTypes.UPDATE_DOCUMENT_TEMPLATE_START,
  payload: { id, active, name, cb },
});

export const updateSmsTemplate = (id, active) => ({
  type: TemplatesActionTypes.UPDATE_SMS_TEMPLATE_START,
  payload: { id, active },
});
